//add color and bar padding properties
import { CommonSchemaIds } from "./common.const.js";
import { ChartConfigurationSchemaIds, ChartConfigurationTags } from "./configuration.const.js";
export const CHART_CONFIGURATION_TLMD_SCHEMAS = {
    [ChartConfigurationSchemaIds.CHART_CONFIGURATION]: {
        id: ChartConfigurationSchemaIds.CHART_CONFIGURATION,
        schema: {
            unevaluatedProperties: false
        },
        properties: {
            visible: {
                ref: CommonSchemaIds.VISIBLE,
                required: true,
                usage: [{ tag: ChartConfigurationTags.DEFAULT }]
            },
            type: {
                ref: CommonSchemaIds.CHART_TYPE,
                required: true,
                usage: [{ tag: ChartConfigurationTags.DEFAULT }]
            }
        }
    }
};
